class LinkHandler {
  constructor(){
    const links = Array.prototype.slice.call(document.querySelectorAll('.js-target-blank'));
    links.forEach(link => {
      link.target = "_blank";
    });
  }
} export default LinkHandler;
